import {debounce} from "lodash";
import {makeAutoObservable, reaction} from "mobx";

export class TextObservable {
  text: string;
  maxLength: number | null;
  validate?: (toValidate: string) => boolean;
  isDirty: boolean;

  // private to prevent overwriting any debounce functionality
  private _onChange?: () => void;

  constructor(
    text: string,
    maxLength?: number | null,
    validate?: (toValidate: string) => boolean,
    onChange?: () => void,
    debounceTimeout?: number
  ) {
    makeAutoObservable(this);
    this.text = text;
    this.maxLength = maxLength ?? null;
    this.validate = validate;
    this.isDirty = false;

    // Adding a debounce of 0 to onChange adds challenge to unit tests
    // As the callback is still delayed slightly. Only debounce if appropriate
    this._onChange =
      debounceTimeout && debounceTimeout > 0
        ? debounce(() => {
            onChange?.();
          }, debounceTimeout)
        : onChange;

    reaction(
      () => this.text,
      () => this.setIsDirty(true)
    );
  }

  isLengthValid = () => {
    return this.maxLength === null || this.text.length <= this.maxLength;
  };

  setIsDirty = (value: boolean) => {
    this.isDirty = value;
  };

  get isValid() {
    return (
      (this.validate == null && this.maxLength == null) ||
      !this.isDirty ||
      (this.isLengthValid() &&
        (this.validate == null || this.validate(this.text)))
    );
  }

  setText = (value: string) => {
    this.text = value;
    this._onChange?.();
  };
}
